

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router';
import Loader from 'react-loader';
import * as d3 from 'd3';
import { SetPlaceName } from '../../actions';
import { simplePlaceName, placeTypeName, plural } from '../../utils/utils';
import Header from '../Header';
import styles from './PlaceList.css';
import withStyles from '../../decorators/withStyles';


class PlaceList extends Component {

  static propTypes = {
    params: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      places: {},
      isLoaded: false,
    }
  }

  async loadData(placeType, query) {
    const placesByContainer = {};
    let url;
    if ('container' in query) {
      url = '/api/metadata/geo/' + encodeURIComponent(placeType) + '?container=' +
        encodeURIComponent(query.container);
    } else {
      url = '/api/metadata/geo/' + encodeURIComponent(placeType);
    }

    const data = await d3.json(url);

    // Group results by geo container
    Object.keys(data).forEach(k => {
      var container = data[k].geo_container;
      data[k].placeID = k;
      if (container.placeID in placesByContainer) {
        placesByContainer[container.placeID].push(data[k]);
      } else {
        placesByContainer[container.placeID] = [data[k]];
      }
    });
    this.setState({places: placesByContainer, isLoaded: true});
  }

  componentWillMount() {
    const placeType = this.props.params.placeType;
    this.props.dispatch(SetPlaceName(plural(placeTypeName(placeType))));
    this.loadData(placeType, this.props.location.query);
  }

  componentWillReceiveProps(props) {
    if (props.params !== this.props.params || props.location.query.container !== this.props.location.query.container) {
      this.setState({places: {}});
      this.loadData(props.params.placeType, props.location.query);
    }
  }

  getPlaceSublist(placeType, places) {
    return places.sort((a, b) => a.name > b.name ? 1 : -1).map((place) => {
      return (
        <li key={`/${placeType}/${place.placeID}`}>
          <Link to={`/${placeType}/${place.placeID}`}>{place.name}</Link>
        </li>
      );
    });
  }

  getPlaceList(placeType, places) {
    return Object.keys(places).sort().map((k) => {
      if (places[k].length === 0) {
        return <div></div>
      } else {
        const placeId = places[k][0].geo_container.placeID;
        const placeName = places[k][0].geo_container.name;
        const placeList = this.getPlaceSublist(placeType, places[k]);
        return (
          <div>
            <h3>
              <a id={placeId} className="anchor"></a>
              {placeName}
            </h3>
            <ul>
              {placeList}
            </ul>
          </div>
        )
      }
    });
  }

  getPlaceListLoader(placeType, places, isLoaded) {
    if (isLoaded) {
      const list = this.getPlaceList(placeType, places);
      return (
        <div>
          {list}
          {this.props.location.query.container && Object.keys(places).length > 0 ?
            <h4><Link to={this.props.location.pathname}>Browse all {plural(placeTypeName(placeType)).toLowerCase()}</Link></h4>
            : <div></div>}
        </div>
      );
    } else {
      return <Loader></Loader>;
    }
  }

  render() {
    window.scroll(0, 0);
    const placeType = this.props.params.placeType;
    const { places, isLoaded } = this.state;
    const placeList = this.getPlaceListLoader(placeType, places, isLoaded);

    return (
      <div>
        <Header mobileMenuOpen={this.props.mobileMenuOpen}
                modalVisible={this.props.modalVisible}
                searchable={this.props.routes[this.props.routes.length - 1].searchable} />
        <main>
          <section className="list">
            {this.props.location.query.container && Object.keys(places).length > 0 ?
              <div>
                <h1>
                  {plural(placeTypeName(placeType))} in {Object.values(places)[0][0].geo_container.name} with risk analysis
                </h1>
              </div>
              :
              <h1>
                All {plural(placeTypeName(placeType)).toLowerCase()} with risk analysis
              </h1>
            }
            <hr/>
            {placeList}
            <hr />
            <p>Don't see what you're looking for? We can provide custom analysis.
                For more, please check out <a href="http://sealevel.climatecentral.org/maps/custom-analysis" target="_blank">our offerings</a>.</p>
          </section>
        </main>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(PlaceList);
